
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }

  // if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE && Flits.Metafields.customer_id != -1){
  //   Flits.LoadStyleScript('cartJs',window.flitsObjects.allCssJs.cartJs.url);
  // }
  if(Flits.Metafields.IS_STORE_CREDIT_PAID && Flits.Metafields.is_store_credit_enable && Flits.Metafields.customer_id != -1){
    if(window.flitsObjects.allCssJs.cartJs){
      Flits.LoadStyleScript('cartJs',window.flitsObjects.allCssJs.cartJs.url);
    }
  }
}(Flits));
